import { render, staticRenderFns } from "./msg-channel.vue?vue&type=template&id=7818f93f"
import script from "./msg-channel.vue?vue&type=script&lang=js"
export * from "./msg-channel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports